import React from 'react';
import {Box, Chip, Tooltip, Typography} from '@mui/material';

const conditionText = link => `${link.requirement} · ${link.operator} · [${link.values.join(', ')}]`;

export function CampaignLinks({links = [], label}) {
    const campaigns = new Map();
    links.forEach(link => {
        if (!campaigns.has(link.campaignId)) campaigns.set(link.campaignId, []);
        campaigns.get(link.campaignId).push(link);
    });
    return <Box onClick={event => event.stopPropagation()} sx={{color: 'text.primary', mt: 0.5}}>
        {links.length === 0 && <Typography variant="caption" color="text.secondary">No</Typography>}
        {links.length > 0 && <Box sx={{display: 'flex', alignItems: 'baseline', gap: 0.75, mb: 0.5, flexWrap: 'wrap'}}>
            {label && <Typography variant="caption" sx={{minWidth: 75}}>{label}:</Typography>}
            {[...campaigns.entries()].map(([key, conditions]) => {
                const campaignId = conditions[0].campaignId;
                const description = conditions.map(conditionText).join('; ');
                return <Tooltip key={key} title={description} arrow
                                componentsProps={{tooltip: {sx: {overflowWrap: 'anywhere'}}}}>
                    <Chip size="small" label={campaignId}
                          tabIndex={0}
                          aria-label={`${campaignId}: ${description}`}
                          sx={{maxWidth: '100%', height: 'auto', '& .MuiChip-label': {whiteSpace: 'normal', overflowWrap: 'anywhere', py: 0.5}}}/>
                </Tooltip>;
            })}
        </Box>}
    </Box>;
}

export function CampaignLinkExclusions({index}) {
    const cohorts = [...index.cohortExcludes.entries()].sort(([a], [b]) => a.localeCompare(b));
    return <>
        {index.testExcludes.length > 0 && <Box component="section" aria-label="Test exclusions" sx={{mt: 1, mb: 1}}>
            <CampaignLinks links={index.testExcludes} label="exclude"/>
        </Box>}
        {cohorts.length > 0 && <Box sx={{mt: 1, mb: 1}}>
            {cohorts.map(([cohortId, links]) => <Box component="section" aria-label={`Cohort ${cohortId} exclusions`} key={cohortId} sx={{ml: 2, mt: 0.5}}>
                <Typography variant="caption">{cohortId}:</Typography>
                <CampaignLinks links={links} label="exclude"/>
            </Box>)}
        </Box>}
    </>;
}
